/* File: cookies.jsx
 * Path: ananunadm/src/helpers/cookies.jsx
*/
import Cookies from "universal-cookie";
import config from "../config";

export const cookies = new Cookies();
export let token = cookies.get(config.api.tokenAddress);

const WEB_COOKIE_EXPIRATION_DAYS = 30;
const TOKEN_REFRESH_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

function decodeJwtPayload(rawToken) {
	if (typeof window === "undefined" || typeof window.atob !== "function") {
		return null;
	}

	const payload = String(rawToken || "").split(".")[1];
	if (!payload) return null;

	try {
		const paddedPayload = payload
			.replace(/-/g, "+")
			.replace(/_/g, "/")
			.padEnd(Math.ceil(payload.length / 4) * 4, "=");
		return JSON.parse(window.atob(paddedPayload));
	} catch (_) {
		return null;
	}
}

function getTokenExpiryDate(rawToken) {
	const decodedPayload = decodeJwtPayload(rawToken);
	const expiresAt = Number(decodedPayload?.exp);
	if (!Number.isFinite(expiresAt) || expiresAt <= 0) {
		return null;
	}

	const expiryDate = new Date(expiresAt * 1000);
	return expiryDate.getTime() > Date.now() ? expiryDate : null;
}

function getCookieExpiryDate(rawToken) {
	const tokenExpiryDate = getTokenExpiryDate(rawToken);
	if (tokenExpiryDate) {
		return tokenExpiryDate;
	}

	const date = new Date();
	date.setDate(date.getDate() + WEB_COOKIE_EXPIRATION_DAYS);
	return date;
}

export function shouldRefreshPrivateToken(rawToken) {
	const expiryDate = getTokenExpiryDate(rawToken);
	if (!expiryDate) return false;
	const remainingMs = expiryDate.getTime() - Date.now();
	return remainingMs > 0 && remainingMs <= TOKEN_REFRESH_WINDOW_MS;
}

export const setCookies = (data) => {
	// Handle empty/null token (logout case)
	if (!data)
	{
		cookies.remove(config.api.tokenAddress, { path: "/" });
		token = null;
		return;
	}

	token = data;

	cookies.set(config.api.tokenAddress, data, {
		path: "/",
		expires: getCookieExpiryDate(data)
	});
};
